import { render, staticRenderFns } from "./OrganizationPassengerPage.vue?vue&type=template&id=ace7a42e"
import script from "./OrganizationPassengerPage.vue?vue&type=script&lang=ts"
export * from "./OrganizationPassengerPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports